import PhoneInputWithCountrySelect from "react-phone-number-input"
import styled from "styled-components"
import { getCssFontStyles } from "../../../typography"

export const PhoneInputContainer = styled.div<{ $fullWidth: boolean }>`
  position: relative;
  width: ${({ $fullWidth }) => {
    return $fullWidth ? "100%" : "21.875rem"
  }};
`
const Tmp = styled(PhoneInputWithCountrySelect)<
  {
    inputAs?: React.ElementType
    $isInError: boolean
    $fullWidth: boolean
  } & React.HTMLProps<HTMLInputElement>
>`
  ${getCssFontStyles("body-4-regular")}

  color: ${({ theme }) => theme.colors.grey.$600};

  height: 2.5rem;
  width: ${({ $fullWidth }) => {
    return $fullWidth ? "100%" : "21.875rem"
  }};

  border-radius: 0.5rem;

  & input[type="tel"] {
    box-sizing: border-box;
    height: 100%;
    padding-left: 0.5rem;
    padding-right: 1.75rem;

    border: 1px solid ${({ theme, $isInError }) => ($isInError ? theme.colors.danger.$200 : theme.colors.grey.$200)};
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    box-shadow: ${({ theme }) => theme.shadows.light};

    transition: all 0.2s ease;
  }

  & input[type="tel"]::placeholder {
    color: ${({ theme }) => theme.colors.grey.$400};
  }

  & input[type="tel"]:active {
    border: 1px solid ${({ theme }) => theme.colors.grey.$600};
  }

  & input[type="tel"]:focus {
    outline: 1px solid ${({ theme }) => theme.colors.grey.$500};
  }

  &.PhoneInput--focus {
    outline: 2px solid ${({ theme }) => theme.colors.grey.$400};
  }

  & input[type="tel"]:disabled {
    border: 1px solid ${({ theme }) => theme.colors.grey.$200};
    background-color: ${({ theme }) => theme.colors.grey.$200};
  }

  & .PhoneInputCountry {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3.625rem;
    height: 100%;
    margin: 0;
    background-color: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme, $isInError }) => ($isInError ? theme.colors.danger.$200 : theme.colors.grey.$200)};
    box-shadow: ${({ theme }) => theme.shadows.light};
    border-right: none;
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }

  & .PhoneInputCountrySelect:focus + .PhoneInputCountryIcon {
    outline: 2px solid ${({ theme }) => theme.colors.grey.$400};
  }

  &.PhoneInput--disabled .PhoneInputCountry {
    background-color: ${({ theme }) => theme.colors.grey.$200};
  }
`

// Due to Vite issue, we need to use a temporary variable to export
export const PhoneInput = Tmp

export const PhoneIcon = styled.svg<{ $isValid: boolean; $isInError: boolean }>`
  color: ${({ $isValid, $isInError, theme }) =>
    $isInError ? theme.colors.danger.$200 : $isValid ? theme.colors.success.$200 : theme.colors.grey.$400};

  position: absolute;
  top: 0.5rem;
  right: 0.25rem;
`
